import { StoreState } from '../../../store/store.interface';

/*----- SELECTORS ------*/
export const isCustomISBN = (state: StoreState) => state.searchState.search?.isCustomISBN || false;
export const isFailure = (state: StoreState) => state.searchState.search?.isFailure;
export const isLoaded = (state: StoreState) => state.searchState.search?.isLoaded;
export const isLoading = (state: StoreState) => state.searchState?.search?.isLoading || false;
export const isSuccess = (state: StoreState) => state.searchState.search?.isSuccess;
export const searchParam = (state: StoreState) => state.searchState.search?.request?.searchTerms;
export const selectPredefinedFilters = (state: StoreState) => state.searchState.predefinedFilters ?? [];
export const selectFacets = (state: StoreState) => state.searchState.search?.data?.facets;
export const selectRequest = (state: StoreState) => state.searchState.search?.request;
export const selectResults = (state: StoreState) => state.searchState.search?.data?.hits;
export const selectSearchData = (state: StoreState) => state.searchState.search?.data;
export const selectSelectedCatalog = (state: StoreState) => state.searchState.selectedCatalog;
export const selectSortBy = (state: StoreState) => state.searchState.search?.request?.sortBy;
export const selectTotal = (state: StoreState) => state.searchState.search?.data?.total;
export const selectBlockedCount = (state: StoreState) => state.searchState.blockedCount || 0;
export const selectAdjustedTotal = (state: StoreState) => {
  const originalTotal = selectTotal(state) || 0;
  const blockedCount = selectBlockedCount(state) || 0;
  return Math.max(0, originalTotal - blockedCount);
};
export const selectView = (state: StoreState) => state.searchState.search?.view;
export const selectSearchPageType = (state: StoreState) => state.searchState?.searchPageType;
export const selectCurrentPageIndex = (state: StoreState) => state.searchState?.currentPageIndex;
export const selectCurrentPageLength = (state: StoreState) => state.searchState?.currentPageLength;

export const selectedFacetCount = (state: StoreState) => {
  const facets = state.searchState.search?.request?.fieldValueFilter || {};
  const facetCount = Object.keys(facets).reduce((count: number, key: string) => {
    if (facets[key] && facets[key].length > 0) count += facets[key].length;
    return count;
  }, 0);
  return facetCount;
};

export const anyFacetSelected = (state: StoreState) => {
  return selectedFacetCount(state) > 0;
};

export const selectRequestFacetValues = (state: StoreState, facetName: string) => {
  return state.searchState.search?.request?.fieldValueFilter?.[facetName]
}
